export class Grupo {
    codigo: number;
    codigoUsuario: string;
    nombre: string;
    grupo_cods: any[];
    nogrupo_cods: any[];
}